type Country = (typeof Country.list)[number];

namespace Country {
  export const list = ["US", "CA"] as const;
  export let current: Country = "US";
}

export default Country;
